<template>
	<div class="flex flex_end w_100">
		<template v-for="item in realList">
			<ShipmentProgressStatusBox :statusTooltip="item.tooltip" :status-code="item.status" :key="item.index"/>
		</template>
	</div>
</template>

<script>
import ShipmentProgressStatusBox from "./ShipmentProgressStatusBox";
import {enumDef} from "@/common/enumDefs";
import {localization} from "@/common/lang/localization";

export default {
  components: {
    ShipmentProgressStatusBox,
  },
  data() {
    return {
		itemList:[],
		currentIndex: 0,
		itemListSupplier: [
			{index: 0, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox0.supplier")},
			{index: 1, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox1.supplier")},
			{index: 2, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox2.supplier")},
			{index: 3, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox3.supplier")},
			{index: 4, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox4.supplier")},
			{index: 5, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox5.supplier")}
		],
		itemListDebtor: [
			{index: 0, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox0.debtor")},
			{index: 1, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox1.debtor")},
			{index: 2, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox2.debtor")},
			{index: 3, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox3.debtor")},
			{index: 4, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox4.debtor")},
			{index: 5, status:"none",tooltip:localization.i18n.t("trackPay.progressStatusBox5.debtor")}
		]
    };
  },
  methods: {
		createItemsForSupplier() {
			this.itemList = this.itemListSupplier
			switch (this.params.data.status) {
				case enumDef.trackPayStats.New:
					this.currentIndex = 0;
					this.itemList[this.currentIndex].status = "orange"
					break;
				case enumDef.trackPayStats.Rejected:
					this.currentIndex = 0;
					this.itemList[this.currentIndex].status = "pink"
					break;
				case enumDef.trackPayStats.Submitted:
					this.currentIndex = 1;
					this.itemList[this.currentIndex].status = "gray"
					break;
				case enumDef.trackPayStats.Confirmed:
				case enumDef.trackPayStats.Transferred:
					this.currentIndex = 2;
					this.itemList[this.currentIndex].status = "gray"
					break;
				case enumDef.trackPayStats.SentToExternal:
					this.currentIndex = 3;
					this.itemList[this.currentIndex].status = "orange"
					break;
				case enumDef.trackPayStats.Tracking:
					this.currentIndex = 4;
					this.itemList[this.currentIndex].status = "gray"
					break;
				case enumDef.trackPayStats.Arrived:
					this.currentIndex = 5;
					this.itemList[this.currentIndex].status = "gray"
					break;
				default:
					break;
			}
		},
		createItemsForDebtor() {
			this.itemList = this.itemListDebtor
			switch (this.params.data.status) {
				case enumDef.trackPayStats.Submitted:
					this.currentIndex = 0;
					this.itemList[this.currentIndex].status = "orange"
					break;
				case enumDef.trackPayStats.Confirmed:
					this.currentIndex = 1;
					this.itemList[this.currentIndex].status = "orange"
					break;
				case enumDef.trackPayStats.Rejected:
					this.currentIndex = 0;
					this.itemList[this.currentIndex].status = "pink"
					break;
				case enumDef.trackPayStats.Transferred:
					this.currentIndex = 2;
					this.itemList[this.currentIndex].status = "gray"
					break;
				case enumDef.trackPayStats.SentToExternal:
				case enumDef.trackPayStats.Tracking:
					this.currentIndex = 3;
					this.itemList[this.currentIndex].status = "gray"
					break;
				case enumDef.trackPayStats.Arrived:
					this.currentIndex = 4;
					this.itemList[this.currentIndex].status = "gray"
					break;
				case enumDef.trackPayStats.Settled:
					this.currentIndex = 5;
					this.itemList[this.currentIndex].status = "orange"
					break;
				default:
					break;
			}
		}
  },
  computed: {
	realList() {
		if (this.params.companyType === 'supplier') {
			this.createItemsForSupplier();
		} else {
			this.createItemsForDebtor();
		}
		let itemList = this.itemList;
		itemList.slice(0, this.currentIndex).map(item => {
			item.status = "green";
		})
		return itemList;
    },
    status() {
      return this.params.data.status;
    }
  }
};
</script>
